import React, { Component } from 'react';

import AppStore from "../flux/AppStore";
import LoadingSpinner from './LoadingSpinner';

import TipBox from './TipBox';
import './LoadingScreenOverlay.css';

class LoadingScreenOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = AppStore.getLoadingScreenOverlayState();

    this.onStateChange = this.onStateChange.bind(this);
  }

  componentDidMount() {
    AppStore.events.showLoadingScreenOverlay.addListener(this.onStateChange);
    AppStore.events.hideLoadingScreenOverlay.addListener(this.onStateChange);
  }

  componentWillUnmount() {
    AppStore.events.showLoadingScreenOverlay.removeListener(this.onStateChange);
    AppStore.events.hideLoadingScreenOverlay.removeListener(this.onStateChange);
  }

  onStateChange() {
    this.setState(AppStore.getLoadingScreenOverlayState());
  }

  render() {
    return this.state.isVisible ? (
      <div className="screenOverlay">
        <LoadingSpinner isVisible={this.state.isVisible} text={this.state.text} />
        <TipBox isVisible={this.state.isVisible} tipsContent="Esistono innumerevoli variazioni dei passaggi del Lorem Ipsum, ma la maggior parte hanno subito delle variazioni del tempo, a causa dell’inserimento di passaggi ironici, o di conseguenze causali di caratteri palesemente poco verosimili." />
      </div>
    ) : null;
  }
}

export default LoadingScreenOverlay;



// WEBPACK FOOTER //
// ./src/components/LoadingScreenOverlay.js